import { render, staticRenderFns } from "./BaseColorPicker.vue?vue&type=template&id=3748969e&scoped=true"
import script from "./BaseColorPicker.vue?vue&type=script&lang=js"
export * from "./BaseColorPicker.vue?vue&type=script&lang=js"
import style0 from "./BaseColorPicker.vue?vue&type=style&index=0&id=3748969e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3748969e",
  null
  
)

export default component.exports